import styled from 'styled-components';
import { Spacer } from '@zillow/constellation';

const LandlordReviewWrapper = styled(Spacer)`
  max-width: 917px;
  margin-left: auto;
  margin-right: auto;

  @media print {
    visibility: visible;
    width: auto;
  }
`;

export default LandlordReviewWrapper;
